// @ts-nocheck

import { setCookie } from './utils';

export default {
  storeExternalReferrer: function () {
    // biome-ignore lint/suspicious/noDoubleEquals: ignored using `--suppress`
    if (document.referrer.search(window.location.origin) == -1) {
      // Overwrite cookie if referrer contains a non-dashboard URL
      setCookie('dashboard_external_referrer', document.referrer, 2);
    }
  },
};
